import React, { createContext, ReactNode, useState } from "react";
import { useTranslation } from "react-i18next";

type LanguageProviderProps = {
  children: ReactNode;
};

type LanguagueContextData = {
  currentLanguage: string;
  handleChangeLanguage: (lang: string) => void;
};

export const LanguageContext = createContext({} as LanguagueContextData);

export function LanguageProvider({ children }: LanguageProviderProps) {
  const { i18n } = useTranslation();
  const [currentLanguage, setCurrentLanguage] = useState(i18n.language);

  const handleChangeLanguage = async (lang: string) => {
    try {
      await i18n.changeLanguage(lang);
      setCurrentLanguage(lang);
    } catch (error) {
      console.error("Erro ao mudar idioma:", error);
    }
  };

  return (
    <LanguageContext.Provider
      value={{
        currentLanguage,
        handleChangeLanguage,
      }}
    >
      {children}
    </LanguageContext.Provider>
  );
}
